export default __webpack_public_path__ + "static/media/gallery_22.a13873ef.jpg";